import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreOptionsService {
  selectedStatus: any;
  selectedBulkStatus: any;
  selectedService: any;
  selectedBranch: any;
  rangeDates: any;
  searchText: any;
  orderId: any;
  bulkOrderId: any;
  bulkSearchText: string;
}